import { jsx as s } from "react/jsx-runtime";
import { f as c, n as a, r as f } from "../../vendor--aJiswR_.js";
import { forwardRef as m } from "react";
import "../../theme/spacing.js";
import { omitStyleRenderProps as i } from "../../utils/omitStyleRenderProps/index.js";
import '../../assets/index6.css';const l = "_link_m06zk_1", d = "_href_m06zk_19", r = {
  link: l,
  href: d
}, x = m(({ children: e, ...o }, t) => {
  const n = c(r.link, {
    [r.href]: !!o.href
  });
  return /* @__PURE__ */ s(
    a,
    {
      ...i(o),
      slot: null,
      ref: t,
      className: n,
      "data-component": "Link",
      children: e
    }
  );
}), b = f;
export {
  x as Link,
  b as RouterProvider
};
//# sourceMappingURL=index.js.map
